import { requiredMessage, minLength, maxLength } from "../utils/common";
var bracketsThenDigits = function bracketsThenDigits(value) {
  return !/^\+?\s?\(?[0-9+\s]+?\)?\s?[0-9\s-]+$/.test(value);
};
var digits = function digits(value) {
  return !/^[0-9]+$/.test(value);
};
var leadingZero = function leadingZero(value) {
  return value.charAt(0) !== "0";
};
var isHomeNumber = function isHomeNumber(value) {
  return /^[0][2-3|7-8][0-9]{8}$/.test(value);
};
var isMobileNumber = function isMobileNumber(value) {
  return /^[0][4][0-9]{8}$/.test(value);
};
var isInvalidAustralianPhoneFormat = function isInvalidAustralianPhoneFormat(value) {
  var phoneNumber = value.replace(/[-()+ ]/g, "");
  return !isHomeNumber(phoneNumber) && !isMobileNumber(phoneNumber);
};
var validPhoneInternational = function validPhoneInternational(value) {
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = requiredMessage("phone number");
  } else if (bracketsThenDigits(value)) {
    error = "Your phone number should only be digits but may contain a plus +, dash -, and/or brackets eg. (61) 0403 - ";
  } else if (minLength(value)(10)) {
    error = "Your phone number must be at least 10 digits.";
  } else if (maxLength(value)(20)) {
    error = "Your phone number must be no more than 20 digits.";
  }
  return error;
};
var validPhoneAustralia = function validPhoneAustralia(value) {
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = requiredMessage("phone number");
  } else if (digits(value)) {
    error = "Your phone number should only be digits.";
  } else if (leadingZero(value)) {
    error = "Please start mobile numbers with 0 and landline numbers with your area code.";
  } else if (minLength(value)(10)) {
    error = "Your phone number should be 10 digits with no spaces.";
  } else if (maxLength(value)(10)) {
    error = "Your phone number should be 10 digits with no spaces.";
  } else if (isInvalidAustralianPhoneFormat(value)) {
    error = "Please enter a valid phone number.";
  }
  return error;
};
var validPhone = function validPhone(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var variant = arguments.length > 2 ? arguments[2] : undefined; // if variant is defined, use that
  if (variant && variant === "international") {
    return validPhoneInternational(value);
  } else if (variant && variant === "australian") {
    return validPhoneAustralia(value);
  } // If no variant, try to guess based on funnel
  if (funnel === "IWHI" || funnel === "IMAN" || funnel === "ISHI") {
    return validPhoneInternational(value);
  }
  return validPhoneAustralia(value);
};
export default validPhone;